import React, { useMemo, useState } from 'react';
import { Card, Tabs, Button, Space } from 'antd';
import { ReloadOutlined, SettingOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminLogSystemPage from './Index';
import InstructionLogConfigPage from './Config';

const LogSystemPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  const defaultKey = useMemo(() => {
    try {
      const p = String(location.pathname || '');
      if (p.endsWith('/log-system/config')) return 'config';
      const sp = new URLSearchParams(location.search);
      const tab = sp.get('tab');
      if (tab === 'config' || tab === 'logs') return tab;
    } catch {}
    return 'logs';
  }, [location.pathname, location.search]);

  const [activeKey, setActiveKey] = useState<string>(defaultKey);
  const titleText = useMemo(() => {
    const isZh = (i18n.language || '').toLowerCase().startsWith('zh');
    if (activeKey === 'config') return isZh ? '日志系统-配置' : 'Log System - Config';
    return isZh ? '日志系统-列表' : 'Log System - List';
  }, [activeKey, i18n.language]);

  const tabLabelLogs = (i18n.language || '').toLowerCase().startsWith('zh') ? '日志列表' : 'Logs';
  const tabLabelConfig = (i18n.language || '').toLowerCase().startsWith('zh') ? '日志配置' : 'Config';

  return (
    <div className="list-page-container">
      <Card>
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <span style={{ fontSize: 18, fontWeight: 600 }}>{titleText}</span>
            </div>
            <Space>
              <Button icon={<ReloadOutlined />} onClick={() => window.location.reload()}>刷新</Button>
            </Space>
          </div>
        </div>
        <Tabs
          activeKey={activeKey}
          onChange={(k) => {
            setActiveKey(k);
            try {
              const url = new URL(window.location.href);
              const tabId = url.searchParams.get('tabId');
              const base = k === 'config' ? '/dashboard/admin/log-system/config' : '/dashboard/admin/log-system';
              const search = new URLSearchParams();
              if (tabId) search.set('tabId', tabId);
              const target = search.toString() ? `${base}?${search.toString()}` : base;
              navigate(target, { replace: true });
            } catch {}
          }}
          items={[
            { key: 'logs', label: tabLabelLogs, children: <AdminLogSystemPage /> },
            { key: 'config', label: tabLabelConfig, children: <InstructionLogConfigPage /> },
          ]}
        />
      </Card>
    </div>
  );
};

export default LogSystemPage;


